import { render, staticRenderFns } from "./AreaEmbargadaGdf.vue?vue&type=template&id=26826388&lang=pug"
import script from "./AreaEmbargadaGdf.vue?vue&type=script&lang=js"
export * from "./AreaEmbargadaGdf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports